const width = 260;

export const baseColumns = [
  { key: 'out_sku_no', name: 'ERP商品编码', align: 'center', width },
  { key: 'out_unit', name: 'ERP商品单位', align: 'center', width },
  { key: 'out_prop', name: '换算系数', align: 'center', width },
];

export const columns = [
  { key: 'sale_name', name: '平台商品名称', align: 'left', width },
  { key: 'sku_no', name: '商品编码', align: 'center', width },
  ...baseColumns
];

export const erpColumns = [
  { name: 'rel_company_name', label: 'ERP供应商名称：', message: '请输入ERP供应商名称!' },
  { name: 'primary_code', label: 'ERP供应商名称编码：', message: '请输入ERP供应商名称编码!' },
  { name: 'sub_code', label: 'ERP供应商二级细分：', message: '请输入ERP供应商二级细分!' },
];

export const erpColumnsSet = new Set();
erpColumns.forEach(item => erpColumnsSet.add(item.name));

export const baseColumnsSet = new Set();
baseColumns.forEach(item => baseColumnsSet.add(item.key));


export const formateErpProducts = currentMap => {
  const defaultValueMap = {};
  const { mappingProducts = [], isRelation, erpMapData = {} } = currentMap;
  if (!isRelation) {
    for (const item of [...erpColumnsSet]) {
      defaultValueMap[`${item}`] = erpMapData[`${item}`] || '';
    }
  }
  for (const item of mappingProducts) {
    for (const subItem of [...baseColumnsSet]) {
      defaultValueMap[`${subItem}_${item.sale_id}`] = erpMapData[`${subItem}_${item.sale_id}`] || '';
    }
  }

  return defaultValueMap;
};